import React from "react";
import { ActorType } from "@common/types/auditLog";
import { RelativeTime } from "@design-system/RelativeTime/RelativeTime";
import { AuditLogActor } from "./AuditLogActor";
import styles from "./AuditLogItem.module.scss";

interface AuditLogItemProps {
    actorId: number | null;
    actorName: string | null;
    actorType: ActorType;
    timestamp: Date;
    children: React.ReactNode;
}

export const AuditLogItem: React.FC<AuditLogItemProps> = ({
    actorId,
    actorName,
    actorType,
    timestamp,
    children,
}) => (
    <div className={styles.item}>
        <div className={styles.simpleMessage}>
            <AuditLogActor
                actorId={actorId}
                actorName={actorName}
                actorType={actorType}
            />
            {children}
            <span className={styles.timestamp}>
                {" "}
                · <RelativeTime date={timestamp} />
            </span>
        </div>
    </div>
);
